import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Open House Upi YPTK
import FormOpenHouse from './OpenHouse/FormOpenHouse';
import ScanOpenHouse from './OpenHouse/ScanOpenHouse';
import QuisionerOpenHouse from './OpenHouse/QuisionerOpenHouse';
import CekDataPendaftar from './OpenHouse/CekDatapendaftar';
import SelfCheckIn from './OpenHouse/SelfCheckIn';

// Gathering UPI Feb 2025
import RegisGathering from './GatheringUpi/RegisGathering';
import CekDataPesertaGathering from './GatheringUpi/CekDataPesertaGathering';
import SelfCheckInGathering from './GatheringUpi/SelfCheckInGathering';
import ScanQrGathering from './GatheringUpi/ScanQrGathering';

// Pembekalan Wisuda
import ScanQRPembekalan from './PembekalanWisuda/ScanQRPembekalan';
import SelfCheckInPembekalan from './PembekalanWisuda/SelfCheckInPembekalan';

// 404
import NotFound from './404/404';

// Home
import Home from './Home';


const App = () => {
  return (
    <div>
    <Router>
          <Routes>
            {/* HOME */}
            <Route path="/" element={<Home />} />

            {/* Open House */}
            <Route path="/openhouse/quisioner" element={<QuisionerOpenHouse />} />
            <Route path="/openhouse/register" element={<FormOpenHouse />} />
            <Route path="/openhouse/qr" element={<ScanOpenHouse />} />
            <Route path="/openhouse/cek" element={<CekDataPendaftar />} />
            <Route path="/openhouse/self-check-in" element={<SelfCheckIn />} />

            {/* Gathering UPI YPTK */}
            <Route path="/gathering-dosen-dan-upi-yptk" element={<RegisGathering />} />
            <Route path="/gathering-repeat-info-search" element={<CekDataPesertaGathering />} />
            <Route path="/self-check-in-gathering-upi-yptk-2025" element={<SelfCheckInGathering />} />
            <Route path="/scan-qr-gathering-2025" element={<ScanQrGathering />} />

            {/* Pembelakan Wisuda  */}
            <Route path="/pembekalan-wisuda/scan" element={<ScanQRPembekalan />} />
            <Route path="/pembekalan-wisuda/self-check-in" element={<SelfCheckInPembekalan />} />

            {/* Rute lain */}
            <Route path="*" element={<NotFound />} />

          </Routes>
    </Router>
    </div>
  );
};


export default App;
